// src/dashboard/Dashboard.jsx
import { useNavigate } from "react-router-dom";
import {
    Book,
    Wallet,
    Users,
    Landmark,
    UserCircle,
    Package,
    PiggyBank, // Using PiggyBank for Bhishi/Savings
    ArrowRight
} from 'lucide-react';

function Dashboard() {
    const dashboardOptions = [
        {
            id: 1,
            title: "Rojmi (Daybook)",
            desc: "Final daily accounting balance",
            path: "/dashboard/rojmi",
            icon: Book,
            color: "from-cyan-500 to-blue-500",
            bg: "bg-cyan-50",
            border: "border-cyan-100",
            text: "text-cyan-600"
        },
        {
            id: 2,
            title: "Daily Transaction",
            desc: "Quick expense logging",
            path: "/dashboard/daily-transaction",
            icon: Wallet,
            color: "from-rose-500 to-pink-500",
            bg: "bg-rose-50",
            border: "border-rose-100",
            text: "text-rose-600"
        },
        {
            id: 3,
            title: "Party Management",
            desc: "Manage Suppliers & Vendors",
            path: "/dashboard/parties",
            icon: Users,
            color: "from-blue-500 to-indigo-500",
            bg: "bg-blue-50",
            border: "border-blue-100",
            text: "text-blue-600"
        },
        {
            id: 4,
            title: "Bank Accounts",
            desc: "Manage Bank Accounts",
            path: "/dashboard/accounts",
            icon: Landmark,
            color: "from-emerald-500 to-teal-500",
            bg: "bg-emerald-50",
            border: "border-emerald-100",
            text: "text-emerald-600"
        },
        {
            id: 7,
            title: "Parcel Management",
            desc: "Track incoming/outgoing goods",
            path: "/dashboard/parcels",
            icon: Package,
            color: "from-indigo-500 to-purple-500",
            bg: "bg-indigo-50",
            border: "border-indigo-100",
            text: "text-indigo-600"
        },
        {
            id: 6,
            title: "Bishi Fund",
            desc: "Track monthly contributions",
            path: "/dashboard/bhishi",
            icon: PiggyBank,
            color: "from-amber-500 to-orange-500",
            bg: "bg-amber-50",
            border: "border-amber-100",
            text: "text-amber-600"
        },
        {
            id: 5,
            title: "Employee",
            desc: "Staff attendance & salaries",
            path: "/dashboard/employees",
            icon: UserCircle,
            color: "from-purple-500 to-violet-500",
            bg: "bg-purple-50",
            border: "border-purple-100",
            text: "text-purple-600"
        },
    ];

    const navigate = useNavigate();

    return (
        <div className="space-y-8">
            <div className="flex items-center justify-between">
                <div>
                    <h2 className="text-2xl font-bold text-slate-800">
                        Dashboard Overview
                    </h2>
                    <p className="text-slate-500 mt-1">
                        Welcome to your control center. Select a module to get started.
                    </p>
                </div>
            </div>

            {/* Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                {dashboardOptions.map((option) => {
                    const Icon = option.icon;
                    return (
                        <div
                            key={option.id}
                            onClick={() => option.path !== '#' && navigate(option.path)}
                            className={`
                                group relative bg-white rounded-2xl p-6 border border-slate-100 
                                hover:border-blue-100/50 hover:shadow-2xl hover:shadow-slate-200/50 hover:-translate-y-1 
                                transition-all duration-300 cursor-pointer overflow-hidden
                                ${option.path === '#' ? 'cursor-not-allowed opacity-60' : ''}
                            `}
                        >
                            <div className="flex flex-col h-full justify-between relative z-10">
                                <div className="flex items-start justify-between mb-6">
                                    <div className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${option.color} flex items-center justify-center text-white shadow-lg shadow-slate-200`}>
                                        <Icon size={28} />
                                    </div>
                                    <div className={`w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300 ${option.bg} ${option.text} group-hover:scale-110`}>
                                        <ArrowRight size={20} className="-rotate-45 group-hover:rotate-0 transition-transform duration-300" />
                                    </div>
                                </div>

                                <div>
                                    <h3 className="text-lg font-bold text-slate-800 group-hover:text-blue-600 transition-colors">
                                        {option.title}
                                    </h3>
                                    <p className="text-slate-400 text-sm font-medium mt-1">
                                        {option.desc}
                                    </p>
                                </div>
                            </div>

                            {/* Decorative Background Gradient Hover */}
                            <div className={`absolute inset-0 bg-gradient-to-br ${option.color} opacity-0 group-hover:opacity-[0.03] transition-opacity duration-300 pointer-events-none`} />
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default Dashboard;